import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { TASK_SERVICE } from '@eggplant/api-hosts'
import type { ReactElement } from 'react'

interface Props {
  onSuccess?: () => void
  children?: () => ReactElement
  taskInstanceId: string
}

const AbortTaskRequest = ({
  onSuccess,
  children,
  taskInstanceId
}: Props) => {
  const url = `${TASK_SERVICE}/abort/${taskInstanceId}`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='post'
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default AbortTaskRequest
